import { createSelector } from 'reselect'
import { selectors as imported } from '../imports'
import { getFallbackAds } from './api'

const getCreativesItems = state => state.creativesReducer.creatives || []
export const isFetching = state => state.creativesReducer.fetching || false

export const getCreatives = createSelector(
    [getCreativesItems, imported.getLocale, imported.isSteamStartup],
    (creatives, locale, isSteam) => {
        if (creatives.length < 1) {
            return getFallbackAds(isSteam, locale)
        }

        return creatives
    },
)



// WEBPACK FOOTER //
// ./src/features/Creatives/data/selectors.js